import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=01a777e8&scoped=true&"
import script from "./Album.vue?vue&type=script&lang=ts&"
export * from "./Album.vue?vue&type=script&lang=ts&"
import style0 from "./Album.vue?vue&type=style&index=0&id=01a777e8&scoped=true&lang=css&"
import style1 from "./Album.vue?vue&type=style&index=1&id=01a777e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a777e8",
  null
  
)

export default component.exports